(function () {
    var CHECK_INTERVAL_MS = 30000;
    var scheduleIntervalId = null;
    var shopTimeAnchor = null;
    var hiddenLastProductCell = null;
  
    function parseScheduleMs(value) {
      if (!value) return null;
      var asSeconds = parseInt(value, 10);
      if (!Number.isNaN(asSeconds)) return asSeconds * 1000;
      var parsed = Date.parse(value);
      return Number.isNaN(parsed) ? null : parsed;
    }
  
    function resetShopTimeAnchor(article) {
      var shopNowSeconds = parseInt(article.getAttribute('data-shop-now'), 10);
      if (Number.isNaN(shopNowSeconds)) {
        shopTimeAnchor = null;
        return;
      }
      shopTimeAnchor = {
        shopMs: shopNowSeconds * 1000,
        browserMs: Date.now()
      };
    }
  
    function shopNowMs() {
      if (!shopTimeAnchor) return Date.now();
      return shopTimeAnchor.shopMs + (Date.now() - shopTimeAnchor.browserMs);
    }
  
    // Inclusive start and end: visible when start <= now <= end
    function isInSchedule(startMs, endMs, nowMs) {
      if (startMs != null && nowMs < startMs) return false;
      if (endMs != null && nowMs > endMs) return false;
      return true;
    }
  
    function setDriverVisibility(article, visible) {
      var cell = article.closest('[data-collection-driver-cell]');
      if (cell) {
        if (cell.classList.contains('collection-driver__grid-cell--out-of-schedule') && visible) {
          cell.classList.remove('collection-driver__grid-cell--out-of-schedule');
        } else if (!cell.classList.contains('collection-driver__grid-cell--out-of-schedule') && !visible) {
          cell.classList.add('collection-driver__grid-cell--out-of-schedule');
        }
      }
      article.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }
  
    function isGridCellVisible(li) {
      return (
        !li.classList.contains('collection-driver__grid-cell--out-of-schedule') &&
        !li.classList.contains('collection-grid__item--schedule-compensate')
      );
    }
  
    function getGridColumnCount(grid) {
      if (window.matchMedia('(min-width: 1080px)').matches) {
        if (grid.classList.contains('css-grid--large-4')) return 4;
        if (grid.classList.contains('css-grid--large-3')) return 3;
        if (grid.classList.contains('css-grid--large-2')) return 2;
        return 4;
      }
      if (window.matchMedia('(min-width: 768px)').matches) {
        if (grid.classList.contains('css-grid--medium-3')) return 3;
        if (grid.classList.contains('css-grid--medium-2')) return 2;
        return 3;
      }
      if (grid.classList.contains('css-grid--small-2')) return 2;
      if (grid.classList.contains('css-grid--small-1')) return 1;
      return 2;
    }
  
    function syncProductGridBorders(grid) {
      grid = grid || document.getElementById('ProductGrid');
      if (!grid) return;
  
      var columns = getGridColumnCount(grid);
      var items = grid.querySelectorAll(':scope > li.css-grid__item');
      var visibleItems = [];
  
      items.forEach(function (li) {
        li.classList.remove('collection-grid__item--last-column');
        if (isGridCellVisible(li)) visibleItems.push(li);
      });
  
      visibleItems.forEach(function (li, index) {
        if ((index + 1) % columns === 0) {
          li.classList.add('collection-grid__item--last-column');
        }
      });
    }
  
    function syncLastProductForDriverVisibility(driverVisible, grid) {
      grid = grid || document.getElementById('ProductGrid');
      if (!grid) return;
  
      if (!driverVisible) {
        if (hiddenLastProductCell) {
          hiddenLastProductCell.classList.remove('collection-grid__item--schedule-compensate');
          hiddenLastProductCell.removeAttribute('aria-hidden');
          hiddenLastProductCell = null;
        }
        return;
      }
  
      if (hiddenLastProductCell && grid.contains(hiddenLastProductCell)) return;
  
      var productCells = grid.querySelectorAll('li.css-grid__item:not([data-collection-driver-cell])');
      if (productCells.length < 20) return;
  
      hiddenLastProductCell = productCells[productCells.length - 1];
      hiddenLastProductCell.classList.add('collection-grid__item--schedule-compensate');
      hiddenLastProductCell.setAttribute('aria-hidden', 'true');
    }
  
    function updateCollectionDriverVisibility(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var articles = scope.querySelectorAll('[data-collection-driver-schedule]');
      if (!articles.length) return;
  
      if (!shopTimeAnchor) {
        resetShopTimeAnchor(articles[0]);
      }
      var nowMs = shopNowMs();
  
      var driverVisible = false;
      var grid = document.getElementById('ProductGrid');
  
      articles.forEach(function (article) {
        var startMs = parseScheduleMs(article.getAttribute('data-schedule-start'));
        var endMs = parseScheduleMs(article.getAttribute('data-schedule-end'));
        var inSchedule = isInSchedule(startMs, endMs, nowMs);
        setDriverVisibility(article, inSchedule);
        if (inSchedule) driverVisible = true;
      });
  
      syncLastProductForDriverVisibility(driverVisible, grid);
      syncProductGridBorders(grid);
    }
  
    window.initCollectionDriverSchedule = function (root) {
      if (scheduleIntervalId) {
        window.clearInterval(scheduleIntervalId);
        scheduleIntervalId = null;
      }
  
      shopTimeAnchor = null;
      hiddenLastProductCell = null;
      updateCollectionDriverVisibility(root);
  
      scheduleIntervalId = window.setInterval(function () {
        updateCollectionDriverVisibility(document);
      }, CHECK_INTERVAL_MS);
    };
  
    var resizeTimer;
    function onGridResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        syncProductGridBorders(document.getElementById('ProductGrid'));
      }, 150);
    }
  
    function onReady() {
      if (document.querySelector('[data-collection-driver-schedule]')) {
        window.initCollectionDriverSchedule(document);
        window.addEventListener('resize', onGridResize);
      }
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }
  })();
  